module.exports = __webpack_public_path__ + "img/img.8a32eccd.png";